import {SerializeClass} from "models/SerializeClass";

export enum ToastLevel {
	NONE = "none",
	ERROR = 'error',
	WARNING = 'warning',
	SUCCESS = 'success',
	INFO = 'info',
}

export class Toast extends SerializeClass {

	private _id: number = (new Date()).getTime();
	private _title: string = "";
	private _message: string = "";
	private _level: ToastLevel = ToastLevel.NONE;
	private _duration: number = 0;
	private _actionLabel: string = "";
	private _action: (() => void) | null = null;

	constructor(message: string, level: ToastLevel, duration: number) {
		super();
		this._message = message;
		this._level = level;
		this._duration = duration;
	}

	/** Attach an action button (e.g. undo) to the toast */
	withAction(label: string, action: () => void): Toast {
		this._actionLabel = label;
		this._action = action;
		return this;
	}

	get actionLabel(): string {
		return this._actionLabel;
	}

	get action(): (() => void) | null {
		return this._action;
	}

	get id(): number {
		return this._id;
	}

	set id(value: number) {
		this._id = value;
	}

	get title(): string {
		return this._title;
	}

	set title(value: string) {
		this._title = value;
	}

	get message(): string {
		return this._message;
	}

	set message(value: string) {
		this._message = value;
	}

	get level(): ToastLevel {
		return this._level;
	}

	set level(value: ToastLevel) {
		this._level = value;
	}


	get duration(): number {
		return this._duration;
	}

	set duration(value: number) {
		this._duration = value;
	}
}